/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum TeamSubscriptionPlanType {
  Free = "Free",
  Paid = "Paid",
  Enterprise = "Enterprise",
}

export enum QueryFlagType {
  Private = "Private",
  MyContent = "MyContent",
}

export enum Orientation {
  Horizontal = "Horizontal",
  Vertical = "Vertical",
  Free = "Free",
}

export enum EntityType {
  None = "None",
  Image = "Image",
  Video = "Video",
  Model = "Model",
  Trace = "Trace",
  Component = "Component",
  Material = "Material",
  Animation = "Animation",
  Style = "Style",
  Form = "Form",
  Template = "Template",
  Any = "Any",
  Scene = "Scene",
  Project = "Project",
  Audio = "Audio",
  Font = "Font",
  Showcase = "Showcase",
  VFX = "VFX",
  Avatar = "Avatar",
  Wrapper = "Wrapper",
}

export enum CreditRefundOutcome {
  Refunded = "Refunded",
  AlreadyRefunded = "AlreadyRefunded",
  DebitNotFound = "DebitNotFound",
}

export enum CreditConsumeOutcome {
  Consumed = "Consumed",
  AlreadyProcessed = "AlreadyProcessed",
  InsufficientBalance = "InsufficientBalance",
  InvalidUnits = "InvalidUnits",
  UnknownAction = "UnknownAction",
}

export enum ContentStorage {
  Legacy = "Legacy",
  Folder = "Folder",
}

export enum AnchorType {
  Local = "Local",
  Temp = "Temp",
  Image = "Image",
  Immersal = "Immersal",
}

export enum AnalyticsGranularity {
  Hour = "Hour",
  Day = "Day",
  Week = "Week",
}

export enum AnalyticsBreakdownDimension {
  Subject = "Subject",
  Platform = "Platform",
  App = "App",
  Event = "Event",
  Context = "Context",
}

export enum AccessType {
  Location = "Location",
  Anywhere = "Anywhere",
}

export interface ActivateSubscriptionResponseDto {
  isSuccess?: boolean;
  message?: string | null;
}

export interface AnalyticsBreakdownItemDto {
  key?: string | null;
  /** @format int64 */
  count?: number;
}

export interface AnalyticsBreakdownResponseDto {
  dimension?: AnalyticsBreakdownDimension;
  items?: AnalyticsBreakdownItemDto[] | null;
}

export interface AnalyticsEventDto {
  /** @format uuid */
  id?: string;
  eventName?: string | null;
  subjectType?: string | null;
  /** @format uuid */
  subjectId?: string;
  /** @format uuid */
  teamId?: string | null;
  /** @format uuid */
  userId?: string | null;
  /** @format uuid */
  sessionId?: string | null;
  clientPlatform?: string | null;
  clientApp?: string | null;
  clientVersion?: string | null;
  context?: string | null;
  /** @format date-time */
  occurredAt?: string;
  /** @format int32 */
  durationMs?: number | null;
  /** @format int32 */
  statusCode?: number;
  properties?: string | null;
}

export interface AnalyticsEventDtoPageResponseDto {
  data?: AnalyticsEventDto[] | null;
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  rowCount?: number;
  /** @format int32 */
  pageCount?: number;
}

export interface AnalyticsSummaryResponseDto {
  /** @format int64 */
  totalEvents?: number;
  /** @format int64 */
  uniqueUsers?: number;
  /** @format int64 */
  uniqueSessions?: number;
  /** @format double */
  avgDurationMs?: number | null;
  /** @format date-time */
  from?: string;
  /** @format date-time */
  to?: string;
}

export interface AnalyticsTimePointDto {
  /** @format date-time */
  time?: string;
  /** @format int64 */
  value?: number;
}

export interface AnalyticsTimeSeriesResponseDto {
  granularity?: AnalyticsGranularity;
  timeZone?: string | null;
  series?: AnalyticsTimePointDto[] | null;
}

export interface AppVersionResponseDto {
  platform?: string | null;
  currentVersion?: string | null;
  minimumVersion?: string | null;
  updateStatus?: string | null;
  updateUrl?: string | null;
  message?: string | null;
  apiVersion?: string | null;
}

export interface AssetCopyRequestDto {
  /** @format uuid */
  teamId?: string;
  /** @format uuid */
  folderId?: string;
  title?: string | null;
  mode?: string | null;
}

export interface AssetCopyResponseDto {
  created?: boolean;
  asset?: AssetResponseDto;
}

export interface AssetFileResponseDto {
  uri?: string | null;
  mimeType?: string | null;
  name?: string | null;
  /** @format int64 */
  size?: number;
  alreadyExisted?: boolean;
}

export interface AssetInsertResponseDto {
  isSuccess?: boolean;
  /** @format uuid */
  assetId?: string | null;
  blobUrl?: string | null;
  blobThumbnailUrl?: string | null;
}

export interface AssetLikeResponseDto {
  /** @format uuid */
  assetId?: string;
  likedByCurrentUser?: boolean;
  /** @format int32 */
  likeCount?: number;
}

export interface AssetResponseDto {
  /** @format uuid */
  assetId?: string;
  title?: string | null;
  description?: string | null;
  url?: string | null;
  thumbnailUrl?: string | null;
  fileType?: string | null;
  originalFilename?: string | null;
  metadata?: any | null;
  fileMetadata?: any | null;
  /** @format uuid */
  folderId?: string | null;
  isLocked?: boolean;
  isSystem?: boolean;
  /** @format date-time */
  dateCreated?: string;
  /** @format date-time */
  dateModified?: string | null;
  /** @format int32 */
  index?: number;
  entityType?: EntityType;
  tags?: TagParentResponseDto[] | null;
  creator?: UserInfoResponseDto;
  pointer?: ContentPointerDto;
}

export interface AssetTransferRequestDto {
  /** @format uuid */
  targetFolderId?: string;
}

export interface AttachProjectSceneRequestDto {
  /** @format uuid */
  teamId: string;
}

export interface AuthTokenResponseDto {
  access_token?: string | null;
  refresh_token?: string | null;
}

export interface AvatarRequestDto {
  name?: string | null;
  src?: string | null;
  type?: string | null;
  icon?: string | null;
  category?: string | null;
  isPublic?: boolean;
}

export interface AvatarResponseDto {
  /** @format uuid */
  id?: string;
  name?: string | null;
  src?: string | null;
  type?: string | null;
  icon?: string | null;
  category?: string | null;
  /** @format uuid */
  userId?: string | null;
  isPublic?: boolean;
  /** @format date-time */
  dateCreated?: string;
}

export interface BlobSweepContainerReport {
  name?: string | null;
  class?: string | null;
  /** @format int32 */
  blobs?: number;
  /** @format int64 */
  bytes?: number;
  /** @format int32 */
  unreferenced?: number;
  /** @format int64 */
  unreferencedBytes?: number;
  /** @format int32 */
  collectable?: number;
  /** @format int64 */
  collectableBytes?: number;
  collectableSamples?: string[] | null;
  /** @format int32 */
  deleted?: number;
  /** @format int64 */
  deletedBytes?: number;
}

export interface BlobSweepContentScan {
  /** @format int32 */
  blobsScanned?: number;
  /** @format int32 */
  archivesRead?: number;
  /** @format int32 */
  textBlobsRead?: number;
  /** @format int32 */
  entriesRead?: number;
  /** @format int32 */
  blobsUnreadable?: number;
  unreadableSamples?: string[] | null;
  /** @format int32 */
  blobsSkippedByLimit?: number;
  /** @format int32 */
  embeddedPaths?: number;
  /** @format int32 */
  candidatesProtected?: number;
}

export interface BlobSweepDryRunRequestDto {
  contentScan?: boolean | null;
  /** @format int32 */
  contentScanMaxBlobs?: number | null;
}

export interface BlobSweepFolderReport {
  folder?: string | null;
  /** @format int32 */
  documents?: number;
  /** @format int32 */
  retainedDocuments?: number;
  /** @format int32 */
  blobs?: number;
  /** @format int64 */
  bytes?: number;
  /** @format int32 */
  referenced?: number;
  /** @format int32 */
  candidates?: number;
  /** @format int64 */
  candidateBytes?: number;
  /** @format int32 */
  unreferencedButYoung?: number;
  /** @format int64 */
  unreferencedBytes?: number;
  candidateSamples?: string[] | null;
  skippedReason?: string | null;
  isOrphan?: boolean;
}

export interface BlobSweepManifestReport {
  container?: string | null;
  /** @format int32 */
  foldersFound?: number;
  /** @format int32 */
  foldersAccounted?: number;
  /** @format int32 */
  foldersSkipped?: number;
  /** @format int32 */
  orphanFolders?: number;
  /** @format int32 */
  orphanFoldersCollectable?: number;
  /** @format int32 */
  foldersWithNoBlobs?: number;
  /** @format int32 */
  unparentedBlobs?: number;
  unparentedSamples?: string[] | null;
  unattributableDocuments?: string[] | null;
  folders?: BlobSweepFolderReport[] | null;
  /** @format int32 */
  foldersNotListed?: number;
}

export interface BlobSweepReport {
  /** @format date-time */
  startedAt?: string;
  /** @format date-time */
  finishedAt?: string;
  mode?: string | null;
  deletesEnabled?: boolean;
  /** @format int32 */
  graceDays?: number;
  /** @format int32 */
  historyDays?: number;
  /** @format int32 */
  historyMinDocuments?: number;
  legacyContainersRequested?: string[] | null;
  contentScanRequested?: boolean;
  aborted?: boolean;
  abortReason?: string | null;
  unknownContainers?: string[] | null;
  missingReferenceColumns?: string[] | null;
  unclassifiedUrlColumns?: string[] | null;
  /** @format int32 */
  referenceValues?: number;
  /** @format int32 */
  distinctReferences?: number;
  danglingReferencesByColumn?: Record<string, number> | null;
  danglingSamplesByColumn?: Record<string, string[]> | null;
  /** @format int32 */
  metadataMentions?: number;
  /** @format int32 */
  metadataPaths?: number;
  /** @format int32 */
  metadataProtected?: number;
  metadataSamples?: string[] | null;
  containers?: BlobSweepContainerReport[] | null;
  /** @format int32 */
  candidateCount?: number;
  /** @format int64 */
  candidateBytes?: number;
  /** @format int32 */
  deletedCount?: number;
  /** @format int64 */
  deletedBytes?: number;
  /** @format int32 */
  deleteFailures?: number;
  deleteCapReached?: boolean;
  contentScan?: BlobSweepContentScan;
  manifest?: BlobSweepManifestReport;
  notes?: string[] | null;
}

export interface BlobSweepRunRequestDto {
  contentScan?: boolean | null;
  /** @format int32 */
  contentScanMaxBlobs?: number | null;
  legacyContainers?: string[] | null;
}

export interface CancelSubscriptionRequestDto {
  cancelReason?: string | null;
}

export interface CancelSubscriptionResponseDto {
  isSuccess?: boolean;
  message?: string | null;
}

export interface CatalogAssetResponseDto {
  /** @format uuid */
  assetId?: string;
  title?: string | null;
  url?: string | null;
  thumbnailUrl?: string | null;
  fileType?: string | null;
  originalFilename?: string | null;
  metadata?: any | null;
  fileMetadata?: any | null;
  /** @format uuid */
  catalogId?: string | null;
  /** @format uuid */
  creatorId?: string | null;
  /** @format date-time */
  dateCreated?: string;
  creator?: UserInfoResponseDto;
  /** @format date-time */
  dateModified?: string | null;
  entityType?: EntityType;
}

export interface CatalogAssetUpdateRequestDto {
  /** @format uuid */
  catalogId?: string | null;
  title?: string | null;
  metadata?: any | null;
}

export interface CatalogEngagementDto {
  /** @format int32 */
  likeCount?: number;
  /** @format int32 */
  useCount?: number;
}

export interface CatalogItemDto {
  /** @format uuid */
  assetId?: string;
  title?: string | null;
  description?: string | null;
  thumbnailUrl?: string | null;
  url?: string | null;
  kind?: EntityType;
  tags?: CatalogTagDto[] | null;
  engagement?: CatalogEngagementDto;
}

export interface CatalogItemDtoPageResponseDto {
  data?: CatalogItemDto[] | null;
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  rowCount?: number;
  /** @format int32 */
  pageCount?: number;
}

export interface CatalogPackDto {
  /** @format uuid */
  packId?: string;
  name?: string | null;
  description?: string | null;
  icon?: string | null;
  /** @format int32 */
  totalAssetCount?: number;
  items?: CatalogPackItemDto[] | null;
}

export interface CatalogPackDtoPageResponseDto {
  data?: CatalogPackDto[] | null;
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  rowCount?: number;
  /** @format int32 */
  pageCount?: number;
}

export interface CatalogPackItemDto {
  /** @format uuid */
  assetId?: string;
  title?: string | null;
  thumbnailUrl?: string | null;
  url?: string | null;
  kind?: EntityType;
}

export interface CatalogResponseDto {
  /** @format uuid */
  id?: string;
  name?: string | null;
  description?: string | null;
  icon?: string | null;
  isDefault?: boolean;
  /** @format date-time */
  createdDate?: string | null;
  catalogAssets?: CatalogAssetResponseDto[] | null;
  /** @format int32 */
  totalAssetCount?: number;
  teamIds?: string[] | null;
  categoryIds?: string[] | null;
}

export interface CatalogResponseDtoPageResponseDto {
  data?: CatalogResponseDto[] | null;
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  rowCount?: number;
  /** @format int32 */
  pageCount?: number;
}

export interface CatalogTagDto {
  /** @format uuid */
  id?: string;
  name?: string | null;
  category?: string | null;
}

export interface CatalogUploadResponseDto {
  isSuccess?: boolean;
  blobUrl?: string | null;
  blobThumbnailUrl?: string | null;
}

export interface CategoryCreateRequestDto {
  name?: string | null;
}

export interface CategoryResponseDto {
  /** @format uuid */
  id?: string;
  name?: string | null;
  /** @format date-time */
  createdDate?: string | null;
  /** @format date-time */
  modifiedDate?: string | null;
}

export interface CategoryUpdateRequestDto {
  name?: string | null;
}

export interface CheckEmailResponseDto {
  accountExists?: boolean;
  isPasswordResetRequired?: boolean;
  isRegistered?: boolean;
  /** @format date-time */
  isLocked?: string | null;
}

export interface ClientLoginDto {
  clientPlatform?: string | null;
  clientApp?: string | null;
  /** @format date-time */
  firstLoginAt?: string;
  /** @format date-time */
  lastLoginAt?: string;
  /** @format int32 */
  loginCount?: number;
}

export interface ConfirmCheckoutSessionResponseDto {
  isProvisioned?: boolean;
  paymentStatus?: string | null;
  sessionKind?: string | null;
  /** @format int32 */
  creditsGranted?: number | null;
}

export interface ConsumeCreditsRequestDto {
  /** @format uuid */
  teamId?: string;
  /** @minLength 1 */
  actionType: string;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  quantity?: number;
  /** @minLength 1 */
  idempotencyKey: string;
  detail?: string | null;
  allowOverdraft?: boolean;
  /**
   * @format int64
   * @min 1
   * @max 9223372036854776000
   */
  quantityMicro?: number | null;
  /** @format uuid */
  userId?: string | null;
}

export interface ContentHistoryEntryDto {
  version?: string | null;
  url?: string | null;
  /** @format date-time */
  createdAt?: string;
  parent?: string | null;
  current?: boolean;
}

export interface ContentPointerDto {
  url?: string | null;
  version?: string | null;
  fileType?: string | null;
  originalFilename?: string | null;
}

export interface ContentRollbackRequestDto {
  version?: string | null;
  /** @format uuid */
  teamId?: string | null;
}

export interface CreateProjectFolderRequestDto {
  title?: string | null;
}

export interface CreateSubscriptionRequestDto {
  lookupKey?: string | null;
  /** @format int32 */
  count?: number;
  /** @format uuid */
  teamId?: string;
  successUrl?: string | null;
  cancelUrl?: string | null;
  transactionId?: string | null;
  /** @format int32 */
  monthlyCredits?: number;
  idempotencyKey?: string | null;
}

export interface CreateSubscriptionResponseDto {
  message?: string | null;
  url?: string | null;
}

export interface CreateTopUpSessionRequestDto {
  /** @format uuid */
  teamId?: string;
  /**
   * @format int32
   * @min 50
   * @max 500000
   */
  amountCents?: number;
  /** @minLength 1 */
  successUrl: string;
  /** @minLength 1 */
  cancelUrl: string;
}

export interface CreditCatalogDto {
  tiers?: CreditTierDto[] | null;
  topUpBuckets?: CreditTopUpBucketDto[] | null;
  /** @format int32 */
  topUpCreditsPerDollar?: number;
  /** @format int32 */
  usageCreditsPerDollar?: number;
  rateCard?: CreditRateCardDto;
}

export interface CreditConsumeResult {
  outcome?: CreditConsumeOutcome;
  /** @format int32 */
  balance?: number;
}

export interface CreditGrantDto {
  /** @format uuid */
  id?: string;
  /** @format int32 */
  amount?: number;
  /** @format int64 */
  amountMicro?: number;
  /** @format int32 */
  remaining?: number;
  /** @format int64 */
  remainingMicro?: number;
  source?: string | null;
  sourceReference?: string | null;
  billingPeriodKey?: string | null;
  /** @format int32 */
  amountCents?: number;
  /** @format date-time */
  grantedAt?: string;
  /** @format date-time */
  expiresAt?: string | null;
  expired?: boolean;
  /** @format uuid */
  grantedByUserId?: string | null;
}

export interface CreditLadderRungDto {
  /** @format int32 */
  rungIndex?: number;
  /** @format int32 */
  credits?: number;
  /** @format int32 */
  addOnPriceCents?: number;
  save?: string | null;
  lookupKey?: string | null;
}

export interface CreditRateCardDto {
  headline?: CreditRateCardLineDto;
  note?: string | null;
  components?: CreditRateCardLineDto[] | null;
}

export interface CreditRateCardLineDto {
  action?: string | null;
  credits?: string | null;
}

export interface CreditRefundResult {
  outcome?: CreditRefundOutcome;
  /** @format int32 */
  balance?: number;
  /** @format int32 */
  refundedUnits?: number;
  /** @format int64 */
  refundedMicro?: number;
}

export interface CreditSettingsDto {
  autoTopUpEnabled?: boolean;
  /**
   * @format int32
   * @min 0
   * @max 1000000
   */
  autoTopUpThreshold?: number;
  /**
   * @format int32
   * @min 0
   * @max 500000
   */
  autoTopUpAmountCents?: number;
  /**
   * @format int32
   * @min 0
   * @max 5000000
   */
  monthlyCapCents?: number | null;
  /** @maxItems 20 */
  alertEmails?: string[] | null;
}

export interface CreditTierDto {
  licenseType?: string | null;
  displayName?: string | null;
  isHeroTier?: boolean;
  /** @format int32 */
  sortPriority?: number;
  /** @format int32 */
  includedCredits?: number;
  ladder?: CreditLadderRungDto[] | null;
}

export interface CreditTopUpBucketDto {
  /** @format int32 */
  amountCents?: number;
  /** @format int32 */
  credits?: number;
  save?: string | null;
}

export interface CustomQuotaRequestDto {
  /** @format int64 */
  projectLimit?: number | null;
  /** @format int64 */
  userLimit?: number | null;
  sku?: string | null;
  /** @format int64 */
  monthlyCredits?: number | null;
}

export interface DeleteAssetRequestDto {
  /** @format uuid */
  teamId: string;
}

export interface DeleteFolderRequestDto {
  /** @format uuid */
  teamId: string;
}

export interface EntityKindDto {
  /** @format int64 */
  bit?: number;
  name?: string | null;
}

export interface ExplorerResponseDto {
  projects?: ProjectResponseDto[] | null;
  scenes?: SceneResponseDto[] | null;
}

export interface FolderResponseDto {
  /** @format uuid */
  folderId?: string;
  title?: string | null;
  /** @format date-time */
  createdDate?: string | null;
}

export interface FolderTeamResponseDto {
  /** @format uuid */
  folderId?: string;
  title?: string | null;
  /** @format date-time */
  dateCreated?: string | null;
  isDefault?: boolean;
  teamFolderPermissionType?: string | null;
  userTeamPermissionType?: string | null;
  /** @format uuid */
  creatorTeamId?: string | null;
  /** @format uuid */
  creatorUserId?: string | null;
}

export interface FolderUpdateRequestDto {
  title?: string | null;
  isDeleted?: boolean | null;
  /** @format uuid */
  teamId: string;
}

export interface GrantCreditsRequestDto {
  /** @format uuid */
  teamId?: string;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  amount?: number;
  reference?: string | null;
  /** @format date-time */
  expiresAt?: string | null;
}

export interface GrantCreditsResponseDto {
  granted?: boolean;
  reference?: string | null;
  credits?: TeamCreditsDto;
}

export interface ImpersonateRequestDto {
  /**
   * @format email
   * @minLength 1
   * @maxLength 256
   */
  targetEmail: string;
}

export interface LicenseDetailDto {
  nickname?: string | null;
  /** @format double */
  price?: number;
  /** @format double */
  userPrice?: number;
  symbol?: string | null;
  lookupKey?: string | null;
  licenseType?: string | null;
  intervalType?: string | null;
  name?: string | null;
  detail?: string | null;
  description?: string | null;
  sku?: string | null;
  isCustom?: boolean;
  isFree?: boolean;
  metadata?: string[] | null;
}

export interface LoginRequestDto {
  email?: string | null;
  password?: string | null;
}

export interface LogoutRequestDto {
  /** @minLength 1 */
  refreshToken: string;
}

export interface MonthlyCreditsDto {
  /** @format int32 */
  allotment?: number;
  /** @format int32 */
  used?: number;
  /** @format date-time */
  resetsAt?: string | null;
  /** @format int32 */
  nextAllotment?: number;
}

export interface OrderRequestDto {
  /** @format uuid */
  id?: string;
  /** @format int32 */
  index?: number;
}

export interface PackToTeamDto {
  assetIds?: string[] | null;
}

export interface PaymentMethodDto {
  id?: string | null;
  cardBrand?: string | null;
  cardLast4?: string | null;
  /** @format int64 */
  cardExpMonth?: number | null;
  /** @format int64 */
  cardExpYear?: number | null;
  isDefault?: boolean;
}

export interface PlatformServiceAccountResponseDto {
  /** @format uuid */
  id?: string;
  email?: string | null;
  displayName?: string | null;
  role?: string | null;
  /** @format date-time */
  dateCreated?: string;
  /** @format int32 */
  usableCredentialCount?: number;
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

export interface ProjectAccessorRequestDto {
  accessType: AccessType;
  address?: string | null;
  /** @format double */
  latitude?: number | null;
  /** @format double */
  longitude?: number | null;
}

export interface ProjectAccessorResponseDto {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  projectId?: string;
  accessType?: string | null;
  address?: string | null;
  /** @format double */
  latitude?: number | null;
  /** @format double */
  longitude?: number | null;
  geohash?: string | null;
  status?: string | null;
  reason?: string | null;
}

export interface ProjectActionRequestDto {
  /** @format uuid */
  teamId: string;
}

export interface ProjectAndScenePermissionsResponseDto {
  /** @format uuid */
  id?: string;
  name?: string | null;
  users?: UserResponseDto[] | null;
  teams?: TeamResponseDto[] | null;
  userInvitations?: UserInvitationResponseDto[] | null;
}

export interface ProjectFolderResponseDto {
  /** @format uuid */
  id?: string;
  title?: string | null;
  isDefault?: boolean;
  /** @format uuid */
  projectId?: string;
  /** @format date-time */
  dateCreated?: string;
  /** @format date-time */
  dateModified?: string | null;
  scenes?: SceneResponseDto[] | null;
}

export interface ProjectResponseDto {
  /** @format uuid */
  id?: string;
  name?: string | null;
  description?: string | null;
  logoUrl?: string | null;
  graphicUrl?: string | null;
  color?: string | null;
  previewLink?: string | null;
  shortCode?: string | null;
  /** @format uuid */
  creatorId?: string | null;
  activationStatus?: string | null;
  anchorId?: string | null;
  pk?: string | null;
  meta?: string | null;
  terms?: string | null;
  disableScreenshots?: boolean;
  header?: string | null;
  isAnnouncement?: boolean;
  allowFolder?: boolean;
  skipWelcomeScreen?: boolean;
  /** @format date-time */
  dateCreated?: string;
  /** @format date-time */
  dateModified?: string | null;
  scenes?: SceneResponseDto[] | null;
  projectAccessors?: ProjectAccessorResponseDto[] | null;
  projectFolders?: ProjectFolderResponseDto[] | null;
  tags?: TagParentResponseDto[] | null;
}

export interface ProjectSceneCodeResponseDto {
  project?: ProjectResponseDto;
  scene?: SceneResponseDto;
  isProject?: boolean;
  isScene?: boolean;
}

export interface RecoverUserRequestDto {
  /**
   * @format email
   * @minLength 1
   * @maxLength 256
   */
  email: string;
}

export interface RefundCreditsRequestDto {
  /** @format uuid */
  teamId?: string;
  /** @minLength 1 */
  idempotencyKey: string;
}

export interface RegisterRequestDto {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  password?: string | null;
  organization?: string | null;
  usageType?: string | null;
  receiveNewsletter?: boolean | null;
}

export interface ResetPasswordRequestDto {
  email?: string | null;
}

export interface SceneAccessorRequestDto {
  accessType: AccessType;
  anchorType: AnchorType;
  orientation?: Orientation;
  /** @format float */
  pitchDegrees?: number | null;
  address?: string | null;
  /** @format double */
  latitude?: number | null;
  /** @format double */
  longitude?: number | null;
}

export interface SceneAccessorResponseDto {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  sceneId?: string;
  accessType?: string | null;
  anchorType?: string | null;
  orientation?: Orientation;
  /** @format float */
  pitchDegrees?: number | null;
  /** @format double */
  latitude?: number | null;
  /** @format double */
  longitude?: number | null;
  address?: string | null;
  geohash?: string | null;
}

export interface SceneActionRequestDto {
  /** @format uuid */
  teamId: string;
}

export interface SceneContentBackfillReport {
  applied?: boolean;
  /** @format int32 */
  rowsExamined?: number;
  /** @format int32 */
  resolved?: number;
  /** @format int32 */
  extensionsCorrected?: number;
  /** @format int32 */
  verified?: number;
  /** @format int32 */
  repointed?: number;
  /** @format int32 */
  unresolved?: number;
  byOutcome?: Record<string, number> | null;
  rows?: SceneContentBackfillRow[] | null;
  /** @format int32 */
  rowsNotListed?: number;
  notes?: string[] | null;
}

export interface SceneContentBackfillRequestDto {
  /** @format int32 */
  maxRows?: number | null;
  recheckFolderRows?: boolean | null;
}

export interface SceneContentBackfillRow {
  /** @format uuid */
  contentId?: string;
  /** @format uuid */
  sceneId?: string;
  outcome?: string | null;
  url?: string | null;
  fileExtension?: string | null;
  detail?: string | null;
}

export interface SceneContentCollectionDto {
  /** @format uuid */
  id?: string;
  name?: string | null;
  /** @format int32 */
  index?: number;
  contents?: SceneContentResponseDto[] | null;
}

export interface SceneContentResponseDto {
  /** @format uuid */
  id?: string;
  version?: string | null;
  name?: string | null;
  /** @format uuid */
  creatorUserId?: string | null;
  authorId?: string | null;
  authorName?: string | null;
  /** @format double */
  duration?: number | null;
  avatarId?: string | null;
  preview?: any | null;
  contentType?: string | null;
  fileExtension?: string | null;
  url?: string | null;
  originalFilename?: string | null;
  pointer?: ContentPointerDto;
  /** @format date-time */
  dateCreated?: string;
  /** @format date-time */
  dateModified?: string | null;
}

export interface SceneCopyRequestDto {
  /** @format uuid */
  teamId?: string | null;
  name?: string | null;
}

export interface SceneFileResponseDto {
  uri?: string | null;
  mimeType?: string | null;
  name?: string | null;
  /** @format int64 */
  size?: number;
  alreadyExisted?: boolean;
}

export interface SceneResponseDto {
  /** @format uuid */
  id?: string;
  name?: string | null;
  description?: string | null;
  anchorId?: string | null;
  pk?: string | null;
  previewLink?: string | null;
  shortCode?: string | null;
  activationStatus?: string | null;
  isAttached?: boolean;
  /** @format uuid */
  projectId?: string | null;
  imageUrl?: string | null;
  /** @format double */
  imageWidth?: number | null;
  imageMetadata?: any | null;
  /** @format uuid */
  creatorId?: string | null;
  /** @format uuid */
  projectFolderId?: string | null;
  /** @format date-time */
  dateCreated?: string;
  /** @format date-time */
  dateModified?: string | null;
  /** @format int32 */
  index?: number;
  sceneAccessors?: SceneAccessorResponseDto[] | null;
  tags?: TagParentResponseDto[] | null;
}

export interface ServiceAccountCreateRequestDto {
  name?: string | null;
  displayName?: string | null;
  permissionType?: string | null;
}

export interface ServiceAccountCredentialCreateRequestDto {
  displayName?: string | null;
  /** @format int32 */
  expiresInDays?: number | null;
}

export interface ServiceAccountCredentialCreatedResponseDto {
  /** @format uuid */
  id?: string;
  clientId?: string | null;
  displayName?: string | null;
  secretLast4?: string | null;
  /** @format date-time */
  dateCreated?: string;
  /** @format date-time */
  expiresAt?: string | null;
  /** @format date-time */
  lastUsedAt?: string | null;
  /** @format date-time */
  revokedAt?: string | null;
  isActive?: boolean;
  clientSecret?: string | null;
  apiKey?: string | null;
}

export interface ServiceAccountCredentialResponseDto {
  /** @format uuid */
  id?: string;
  clientId?: string | null;
  displayName?: string | null;
  secretLast4?: string | null;
  /** @format date-time */
  dateCreated?: string;
  /** @format date-time */
  expiresAt?: string | null;
  /** @format date-time */
  lastUsedAt?: string | null;
  /** @format date-time */
  revokedAt?: string | null;
  isActive?: boolean;
}

export interface ServiceAccountResponseDto {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  teamId?: string;
  name?: string | null;
  displayName?: string | null;
  email?: string | null;
  permissionType?: string | null;
  /** @format date-time */
  dateCreated?: string;
}

export interface ServiceAccountUpdateRequestDto {
  displayName?: string | null;
  permissionType?: string | null;
}

export interface SetupIntentResponseDto {
  customerId?: string | null;
  clientSecret?: string | null;
}

export interface SubscriptionInvoiceResponseDto {
  fileUrl?: string | null;
  /** @format double */
  amount?: number;
  description?: string | null;
  status?: string | null;
  /** @format uuid */
  teamId?: string | null;
  customerEmail?: string | null;
}

export interface TagChildrenResponseDto {
  /** @format uuid */
  id?: string;
  name?: string | null;
  /** @format uuid */
  parentTagId?: string | null;
  bgColor?: string | null;
  url?: string | null;
  /** @format uuid */
  ownerTeamId?: string | null;
}

export interface TagParentResponseDto {
  /** @format uuid */
  id?: string;
  name?: string | null;
  entityType?: EntityType;
  bgColor?: string | null;
  url?: string | null;
  allowTeamTerms?: boolean;
  children?: TagChildrenResponseDto[] | null;
}

export interface TeamAddRequestDto {
  /** @format uuid */
  teamId?: string;
  permissionType?: string | null;
}

export interface TeamCreateRequestDto {
  name?: string | null;
  description?: string | null;
  profileImageUrl?: string | null;
  profileImageThumbnailUrl?: string | null;
  profileImageSmallThumbnailUrl?: string | null;
  members?: TeamMemberAddRequestDto[] | null;
}

export interface TeamCreateResponseDto {
  /** @format uuid */
  teamId?: string;
  name?: string | null;
  members?: string[] | null;
}

export interface TeamCreditGrantsDto {
  /** @format uuid */
  teamId?: string;
  /** @format int32 */
  limit?: number;
  grants?: CreditGrantDto[] | null;
}

export interface TeamCreditsDto {
  /** @format int32 */
  balance?: number;
  /** @format int64 */
  balanceMicro?: number;
  monthly?: MonthlyCreditsDto;
}

export interface TeamFolderCreateRequestDto {
  /** @format uuid */
  teamId: string;
  title: string | null;
}

export interface TeamFolderShareRequestDto {
  /** @format uuid */
  teamId: string;
  teams?: TeamAddRequestDto[] | null;
  updatePermissions?: TeamPermissionRequestDto[] | null;
  revokeAccess?: string[] | null;
}

export interface TeamFoldersResponseDto {
  /** @format uuid */
  teamId?: string | null;
  teamName?: string | null;
  isDefault?: boolean;
  folders?: FolderTeamResponseDto[] | null;
  defaultPacks?: CatalogResponseDto[] | null;
}

export interface TeamMemberAddRequestDto {
  email?: string | null;
  permissionType?: string | null;
}

export interface TeamPermissionRequestDto {
  /** @format uuid */
  teamId?: string;
  permissionType?: string | null;
}

export interface TeamProjectShareRequestDto {
  /** @format uuid */
  teamId: string;
  teams?: TeamAddRequestDto[] | null;
  updatePermissions?: TeamPermissionRequestDto[] | null;
  revokeAccess?: string[] | null;
}

export interface TeamQuotaDto {
  /** @format int64 */
  assetsLimit?: number | null;
  /** @format int64 */
  projectLimit?: number;
  /** @format int64 */
  projectSceneLimit?: number | null;
  /** @format int64 */
  sceneLimit?: number | null;
  /** @format int64 */
  userLimit?: number;
  /** @format int64 */
  fileSize?: number | null;
}

export interface TeamResponseDto {
  /** @format uuid */
  teamId?: string | null;
  name?: string | null;
  description?: string | null;
  isOwner?: boolean | null;
  profileImageUrl?: string | null;
  profileImageThumbnailUrl?: string | null;
  profileImageSmallThumbnailUrl?: string | null;
  permissionType?: string | null;
  members?: UserInfoResponseDto[] | null;
}

export interface TeamSettingDto {
  /** @format uuid */
  teamId?: string;
  /** @format int32 */
  existingUserCount?: number;
  /** @format int32 */
  existingActiveProjectCount?: number;
  /** @format int32 */
  existingActiveSceneCount?: number;
  /** @format int32 */
  existingAssetCount?: number;
  isOwner?: boolean;
  subscriptionInfos?: TeamSubscriptionInfo[] | null;
  teamQuota?: TeamQuotaDto;
}

export interface TeamSubscriptionInfo {
  /** @format date-time */
  expireAt?: string | null;
  /** @format date-time */
  currentPeriodEnd?: string | null;
  isFree?: boolean;
  isCustom?: boolean;
  sku?: string | null;
  subsctiptionSource?: string | null;
  hasCanceled?: boolean;
  /** @format date-time */
  cancelAt?: string | null;
  subscriptionStatus?: string | null;
  /** @format double */
  projectSubscriptionAmount?: number;
  /** @format double */
  addOnUserAmount?: number;
  /** @format int64 */
  projectSubscriptionCount?: number;
  /** @format int64 */
  addOnUserCount?: number;
  /** @format double */
  creditsAddOnAmount?: number;
  isOverDue?: boolean;
}

export interface TeamUpdateRequestDto {
  name?: string | null;
  description?: string | null;
  profileImageUrl?: string | null;
  profileImageThumbnailUrl?: string | null;
  profileImageSmallThumbnailUrl?: string | null;
  members?: TeamMemberAddRequestDto[] | null;
  updatePermissions?: UserPermissionRequestDto[] | null;
  revokeAccess?: string[] | null;
  revokeAccessUnregistered?: string[] | null;
}

export interface TeamUserResponseDto {
  /** @format uuid */
  teamId?: string;
  /** @format uuid */
  userId?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  /** @format date-time */
  dateOfBirth?: string | null;
  /** @format date-time */
  dateCreated?: string | null;
  /** @format date-time */
  dateModified?: string | null;
  profileImageSmallThumbUrl?: string | null;
  isCreator?: boolean | null;
  permissionType?: string | null;
  isServiceAccount?: boolean;
}

export interface TeamUsersResponseDto {
  /** @format uuid */
  teamId?: string;
  teamUsers?: TeamUserResponseDto[] | null;
  userInvitations?: UserInvitationResponseDto[] | null;
}

export interface TransferRequestDto {
  /** @format uuid */
  targetTeamId?: string;
}

export interface UpdatePasswordExternalRequestDto {
  email?: string | null;
  newPassword?: string | null;
  token?: string | null;
}

export interface UpdatePasswordRequestDto {
  email?: string | null;
  currentPassword?: string | null;
  newPassword?: string | null;
}

export interface UpdateProjectFolderRequestDto {
  title?: string | null;
}

export interface UpdateSubscriptionPaymentMethodDto {
  /** @format uuid */
  teamId?: string;
}

export interface UpdateSubscriptionResponseDto {
  message?: string | null;
}

export interface UpdateUserSubscriptionRequestDto {
  /** @format int32 */
  count?: number;
  /** @format uuid */
  teamId?: string;
}

export interface UpsertAppVersionRequestDto {
  latestVersion?: string | null;
  minimumVersion?: string | null;
  updateUrl?: string | null;
  message?: string | null;
}

export interface UserAddRequestDto {
  email?: string | null;
  permissionType?: string | null;
}

export interface UserFolderShareRequestDto {
  /** @format uuid */
  teamId: string;
  members?: UserAddRequestDto[] | null;
  updatePermissions?: UserPermissionRequestDto[] | null;
  revokeAccess?: string[] | null;
  revokeAccessUnregistered?: string[] | null;
}

export interface UserInfoResponseDto {
  /** @format uuid */
  userId?: string;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  userAlias?: string | null;
  profileImageSmallThumbnailUrl?: string | null;
}

export interface UserInvitationRequestDto {
  /** @format uuid */
  teamId?: string | null;
  /** @format uuid */
  folderId?: string | null;
  /** @format uuid */
  projectId?: string | null;
  /** @format uuid */
  sceneId?: string | null;
  email?: string | null;
  permissionType?: string | null;
}

export interface UserInvitationResponseDto {
  email?: string | null;
  permissionType?: string | null;
}

export interface UserPermissionRequestDto {
  /** @format uuid */
  userId?: string;
  permissionType?: string | null;
}

export interface UserProjectShareRequestDto {
  /** @format uuid */
  teamId: string;
  members?: UserAddRequestDto[] | null;
  updatePermissions?: UserPermissionRequestDto[] | null;
  revokeAccess?: string[] | null;
  revokeAccessUnregistered?: string[] | null;
}

export interface UserResponseDto {
  /** @format uuid */
  userId?: string;
  /** @format uuid */
  userAccountId?: string;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  middleName?: string | null;
  userAlias?: string | null;
  /** @format date-time */
  dateOfBirth?: string | null;
  profileImageUrl?: string | null;
  profileImageThumbnailUrl?: string | null;
  profileImageSmallThumbnailUrl?: string | null;
  permissionType?: string | null;
  organization?: string | null;
  usageType?: string | null;
  receiveNewsletter?: boolean | null;
  /** @format date-time */
  datePasswordChanged?: string | null;
  applicationRole?: string | null;
  isSceneTutorialComplete?: boolean;
  isProjectTutorialComplete?: boolean;
  isAssetTutorialComplete?: boolean;
  isContentTutorialComplete?: boolean;
  isProjectManagerTutorialComplete?: boolean;
  isSubscriptionTutorialComplete?: boolean;
  isLearningTutorialCompleted?: boolean;
  /** @format date-time */
  joiningDate?: string | null;
  /** @format date-time */
  lastLoginDate?: string | null;
  clientLogins?: ClientLoginDto[] | null;
}

export interface UserSceneShareRequestDto {
  /** @format uuid */
  teamId: string;
  members?: UserAddRequestDto[] | null;
  updatePermissions?: UserPermissionRequestDto[] | null;
  revokeAccess?: string[] | null;
  revokeAccessUnregistered?: string[] | null;
}

export interface UserTeamRequestDto {
  /** @format uuid */
  teamId?: string;
  members?: TeamMemberAddRequestDto[] | null;
}

export interface UserTeamResponseDto {
  /** @format uuid */
  teamId?: string;
  /** @format uuid */
  userId?: string;
  isCreator?: boolean | null;
  name?: string | null;
  isDefault?: boolean;
  description?: string | null;
  profileImageUrl?: string | null;
  profileImageThumbnailUrl?: string | null;
  profileImageSmallThumbnailUrl?: string | null;
  permissionType?: string | null;
  /** @format date-time */
  dateCreated?: string;
  subscriptionType?: TeamSubscriptionPlanType;
}

export interface UserUpdateRequestDto {
  firstName?: string | null;
  lastName?: string | null;
  middleName?: string | null;
  userAlias?: string | null;
  /** @format date-time */
  dateOfBirth?: string | null;
  userEmail?: string | null;
  profileImageUrl?: string | null;
  profileImageThumbnailUrl?: string | null;
  profileImageSmallThumbnailUrl?: string | null;
  organization?: string | null;
  usageType?: string | null;
  receiveNewsletter?: boolean | null;
  isSceneTutorialComplete?: boolean | null;
  isProjectTutorialComplete?: boolean | null;
  isAssetTutorialComplete?: boolean | null;
  isContentTutorialComplete?: boolean | null;
  isProjectManagerTutorialComplete?: boolean | null;
  isSubscriptionTutorialComplete?: boolean | null;
  isLearningTutorialCompleted?: boolean | null;
}

export interface UsersTeamsFolderResponseDto {
  /** @format uuid */
  folderId?: string;
  folderName?: string | null;
  users?: UserResponseDto[] | null;
  teams?: TeamResponseDto[] | null;
  userInvitations?: UserInvitationResponseDto[] | null;
}
